import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { createCaseManagement, getCaseManagements } from "../../../redux/actions/managementActions";
import mdiFileDocumentPlusOutline from '../../../shared/img/document-plus.svg';
import CaseManagementModal from './CaseManagementModal';

const initialManagementValues = { managementType: '', comment: '' };

const CaseManagement = (props) => {
  const { createCaseManagement, getCaseManagements, managementCreated, params } = props;

  const [showModal, setShowModal] = useState(false);
  const [managementData, setManagementData] = useState(initialManagementValues);

  const toggle = () => setShowModal(!showModal);

  const handleSubmit = (e) => {
    e.preventDefault();
    let body = {
      "description": managementData.comment,
      "caseId": params.id,
      "typeId": managementData.managementType
    }
    createCaseManagement(body, (res) => {
      if (res.status === 201) {
        getCaseManagements(params.id);
        setManagementData(initialManagementValues);
        toggle();
      }
    });
  }

  const handleChange = (e) => {
    const target = e.target;
    setManagementData((prevValues) => ({ ...prevValues, [target.name]: target.value }));
  };

  return (
    <div className="crm-case-management-container col-md-12">
      <CaseManagementModal
        toggle={toggle}
        modal={showModal}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        managementData={managementData}
        managementCreated={managementCreated}
      />
      <span className="datos-personales">Gestión del caso</span>
      <div className="crm-management-content">
        <button className="crm-management-btn" type="button" onClick={toggle}>
          <img src={mdiFileDocumentPlusOutline} alt="Nueva Gestión" />Nueva Gestión
        </button>
      </div>
    </div>
  );
}

CaseManagement.propTypes = {
  createCaseManagement: PropTypes.func,
  getCaseManagements: PropTypes.func,
  params: PropTypes.object,
  managementCreated: PropTypes.shape({
    loading: PropTypes.bool
  })
};

const mapStateToProps = ({ management }) => ({
  managementCreated: management.managementCaseCreated,
});

const mapDispatchToProps = { createCaseManagement, getCaseManagements };

export default connect(mapStateToProps, mapDispatchToProps)(CaseManagement);